var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ft-input",class:{'-placeholder': !_vm.value}},[_c('textarea',{staticClass:"input",attrs:{"type":"text","placeholder":_vm.info.placeholder},domProps:{"value":_vm.info.value},on:{"input":_vm.onInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }